import React, { Component } from 'react';
import axios from 'axios';
import DatePicker from "react-datepicker";
import {APIURL} from "../../../config/config";
import moment from "moment";
import {AlertSuccess} from "../../Alert/Alert";


class AppointmentForm extends Component{

    constructor(props){
        super(props);
        this.state = {
            lists: [],
            load_data: true,
            danger: false,
            appointment:'',
            appointment_list:[],
            appointment_date : new Date(),
            appointment_detail : '',
        }
        this.handleDateAppoinment = this.handleDateAppoinment.bind(this);
        this.handleOnSubmitAddAppointment = this.handleOnSubmitAddAppointment.bind(this);
    }

    handleDateAppoinment(date) {
        this.setState({
            appointment_date: date
        });
    }

    handleOnSubmitAddAppointment(event){
        event.preventDefault()

        let appointment_list_id = this.refs.appointment_list_id.value
        let appointment_date = moment(this.state.appointment_date).format('YYYY-MM-DD')
        let appointment_detail = this.refs.appointment_detail.value
        let user = this.props.user
        // console.log(appointment_list_id, appointment_date, appointment_detail, user)
        // return;
        /*let appointment_list_id = event.target.appointment_list_id.value
        let appointment_date = moment(this.state.appointment_date).format('YYYY-MM-DD')
        let appointment_detail = event.target.appointment_detail.value*/

        if(appointment_list_id === ''){
            alert('กรุณาเลือกรายการนัดหมาย')
            return;
        }

        const data = new FormData();
        data.append('appointment_list_id', appointment_list_id);
        data.append('appointment_date', appointment_date);
        data.append('appointment_detail', appointment_detail);
        data.append('user', user);
        // data.append('user_created', this.state.user.user);
        // data.append('user_updated', this.state.user.user);
        const  data2 = {
            appointment_list_id,
            appointment_date,
            appointment_detail,
            user

        }

        axios.post(APIURL + '/appointment/', data2)
            .then(response => {
                // console.log('add expense')
                // console.log(response.data)
                let result = response.data.result
                if(result === 'success'){
                    this.props.onToggle();
                    AlertSuccess("เพิ่มการนัดหมายเรียบร้อยแล้ว")
                    this.props.onReload();
                }
                // this.props.onToggle();
                // this.props.onReload();
            })
            .catch(function (error) {
                //console.log(error)
                //alert("error"+error)
            })

        /*axios.post(APIURL + '/appointment/', {
            appointment_list_id : appointment_list_id,
            appointment_date : appointment_date,
            appointment_detail : appointment_detail,
            status_field: 'show'

        })
            .then(res => {
                if(res.status === 200)
                    this.props.onToggle()
            })
            .catch(error => {
                alert("error: "+error)
            })*/
    }


    loadAppointmentListData () {
        axios.get(APIURL + '/appointment_list/')
            .then(res => this.setState({appointment_list: res.data}))
            .catch(error => {
                this.setState({appointment_list: []})
            })
    }


    componentDidMount() {
        this.loadAppointmentListData()
        // this.loadAppointmentData()
    }

    render(){

        let appointment_list = this.state.appointment_list.map((appointment_list,index)=>{
            return(
                <option key={index} value={appointment_list.appointment_list_id}>{appointment_list.appointment_list_name}</option>
            )
        })

        return(
            <div className="card card-accent-primary">
                <form action="" method="post"  onSubmit={this.handleOnSubmitAddAppointment.bind(this)}>
                    <div className="card-header">
                        <strong className="text-title">เพิ่มข้อมูลนัดหมาย</strong>
                    </div>

                    <div className="card-block">
                        <div className="row">
                            <div className="form-group col-sm-3">
                                <label htmlFor="appointment_date">วันที่นัดหมาย :</label>
                            </div>
                            <div className="form-group col-sm-9">
                                <DatePicker
                                    selected={this.state.appointment_date}
                                    onChange={this.handleDateAppoinment}
                                    dateFormat="yyyy-MM-dd"
                                    type="text"
                                    className="form-control"
                                    id="appointment_date"
                                    ref="appointment_date"
                                    name="appointment_date"
                                    placeholder=""
                                />
                            </div>

                            <div className="form-group col-sm-3">
                                <label htmlFor="appointment_list_id">รายการนัดหมาย :</label>
                            </div>
                            <div className="form-group col-sm-6">
                                <select
                                    className="form-control"
                                    id="appointment_list_id"
                                    ref="appointment_list_id"
                                    name="appointment_list_id"
                                >
                                    {appointment_list}
                                </select>
                            </div>

                            <div className="form-group col-sm-3"/>

                            <div className="form-group col-sm-3">
                                <label htmlFor="appointment_detail">ข้อความนัดหมาย :</label>
                            </div>
                            <div className="form-group col-sm-6">
                                <textarea className="form-control"
                                          placeholder="ใส่รายละเอียดเช่น ชื่อลูกค้า / รายละเอียดรถ"
                                          id="appointment_detail"
                                          ref="appointment_detail"
                                          name="appointment_detail"
                                          rows={8}
                                >
                                </textarea>
                            </div>

                            <div className="col-sm-12 text-center">
                                <div className="card-block">
                                    <button type="reset"
                                            className="btn  btn-danger mr-3" style={styles.btnWidth}
                                            onClick={this.props.onToggle}
                                    >
                                        <i className="fa fa-refresh"/> ยกเลิก</button>

                                    <button type="submit" className="btn btn-success"  style={styles.btnWidth} >
                                        <i className="icon-check"/>  บันทึกการนัดหมาย</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const styles = {
    bottomLine: {
        borderBottomColor: '#ccc',
        borderBottomStyle: 'solid',
        borderWidth: 0.5,
    },
    btnWidth: {
        width: 170,
    }
}


export default (AppointmentForm);